import { get as lodashGet } from 'lodash';
import store from '../store';

export class RequestError extends Error {
  constructor(statusCode, body) {
    super(`Request failed with status code: ${statusCode}`);
    this.statusCode = statusCode;
    this.body = body;
  }
}

const parseErrorBody = async (response) => {
  const text = await response.text();
  if (!text?.trim()) return undefined;
  if (text.trimStart().startsWith('<')) return { _raw: 'Non-JSON response (e.g. HTML 404 page)' };
  try {
    return JSON.parse(text);
  } catch {
    return { _raw: text.slice(0, 200) };
  }
};

export const handleResponse = async (response) => {
  if (!response.ok) {
    const body = await parseErrorBody(response);
    const err = new RequestError(response.status, body);
    err.statusCode = response.status;
    throw err;
  }

  if (response.status === 204) {
    return undefined;
  }

  return response.json();
};

export const post = async (url, data = {}) => {
  const res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'AMP-User-Id': lodashGet(store.getState(), 'authentication.userData._id', 'dashboard'),
    },
    credentials: 'include',
  });

  return handleResponse(res);
};

export const patch = async (url, data = {}) => {
  const res = await fetch(url, {
    method: 'PATCH',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'AMP-User-Id': lodashGet(store.getState(), 'authentication.userData._id', 'dashboard'),
    },
    credentials: 'include',
  });

  return handleResponse(res);
};

export const callDelete = async (url, data) => {
  const headers = {
    Accept: 'application/json',
    'AMP-User-Id': lodashGet(store.getState(), 'authentication.userData._id', 'dashboard'),
  };
  if (data !== undefined && data !== null) {
    headers['Content-Type'] = 'application/json';
  }
  const res = await fetch(url, {
    method: 'DELETE',
    body: data !== undefined && data !== null ? JSON.stringify(data) : undefined,
    headers,
    credentials: 'include',
  });

  return handleResponse(res);
};

export const get = async (url) => {
  const res = await fetch(url, {
    headers: {
      Accept: 'application/json',
      'AMP-User-Id': lodashGet(store.getState(), 'authentication.userData._id', 'dashboard'),
    },
    credentials: 'include',
  });

  return handleResponse(res);
};

export const put = async (url, data = {}) => {
  const res = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'AMP-User-Id': lodashGet(store.getState(), 'authentication.userData._id', 'dashboard'),
    },
    credentials: 'include',
  });

  return handleResponse(res);
};
